<template>
  <Walkthrough 
    roomName="Auto"
    roomKey="car"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="german"
  />
</template>
<script>

export default {
  name: 'Car',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/car-1920x1280.jpg",
      steps: [
        "Schau nach rechts und betrachte den Sitz. Du findest dort einen Schraubenzieher.",
        "Schau nach oben und benutze den Schraubenzieher, um die Lampe abzunehmen. Nachdem du die Lampe abgeschraubt hast, findest du darin ein Messer.",
        "Schau nach unten und benutze dein Messer am Sicherheitsgurt. So kannst du dich befreien und zur Vorderseite des Autos bewegen.",
        "Guck dir den Getränkehalter links von dir genau an. Da hat wohl jemand einen Fehler gemacht und dir einen Schlüssel dagelassen.",
        "Schau nach vorne und benutze den Schraubenzieher, um das Armaturenbrett abzunehmen. Das bringt ein paar Kabel zum Vorschein.",
        "Guck weiter nach vorne und öffne das Handschuhfach mit dem Schlüssel. Darin findest du Isolierband. ",
        "Der weiße Umschlag hat eine deutsche Flagge. Weiß, schwarz rot Gelb. ",
        "Du kennst jetzt die Farben der Kabel, die du verbinden musst. Verbinde mit dem Isolierband das rote, schwarze, gelbe und weiße Kabel. Das Auto sollte anspringen!",
        "Schau nach unten und betrachte die Fußmatte. Du findest ein Nummernschild und dir fällt auf, dass die römischen Zahlen darauf 2415 ergeben. Das ist der Code für den Safe!",
        "Schau nach vorne und gib den Code 2415 in den Safe ein. Wenn der Safe sich öffnet, findest du darin einen Vorschlaghammer.",
        "Benutze den Vorschlaghammer, um die Windschutzscheibe einzuschlagen und zu entkommen! Versuche, aus dem nächsten Raum alleine zu fliehen!",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/de/car.vue